import { inject, observer } from "mobx-react";
import * as React from "react";
import { ButtonGroup } from "reactstrap";
import Button from "reactstrap/lib/Button";
import DataTable from "src/Components/DataTable";
import { IWell } from "src/Interfaces/WellInterface";
import { WellsStore } from "src/Stores/Wells/WellsStore";

interface ISelectTableProps {
    onClear?: any;
}

@inject('stores')
@observer
class CopyWellSelectTable extends React.Component {
    public props: ISelectTableProps;
    private WellsStore: WellsStore;
    public state = {
        typeFilters: [] as string[],
    };

    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
    }

    public componentDidMount() {
        if (this.WellsStore.copyWellList === undefined) {
            this.WellsStore.getCopyWellList();
        }
    }

    public getOperatorName = (well: IWell) => {
        if (well.operator && well.operator.operatorName) {
            return well.operator.operatorName;
        }
        return '';
    }

    public getContractorName = (well: IWell) => {
        if (well.contractor && well.contractor.contractorName) {
            return well.contractor.contractorName;
        }
        return '';
    }
    public formatWellTable = () => {
        const headers = [
            'Well Name',
            'Operator',
            'Contractor',
        ];
        const wellList = this.WellsStore.copyWellList;
        if (wellList === undefined) {
            return { headers, rows: []};
        }

        const rows = wellList.filter(this.filterList).map(well => [
            {
                content: well.wellName,
            },
            {
                content: this.getOperatorName(well),
            },
            {
                content: this.getContractorName(well) + ' ' + well.rigNumber,
            },
        ]);

        return { headers, rows };
    }

    public selectWell = (index: number) => {
        const wellList = this.WellsStore.copyWellList.filter(this.filterList);
        this.WellsStore.getCopyWellDetails(wellList[index].id);
    }

    public clearWell = () => {
        this.WellsStore.clearCopyWellDetails();
        if (this.props.onClear) {
            this.props.onClear();
        }
    }

    public filterList = (item: IWell) => {
        if (item.id === this.WellsStore.well.id)
        {
            return false;
        }
        let resultType;
        if (this.state.typeFilters.length === 0) {
            resultType = true;
        } else {

            for (const filterName of this.state.typeFilters)
            {
                if (item.wellStatus === filterName) {
                    resultType = true;
                }
            }
        }
        return resultType === true;
    }

    public buttonColor = (buttonName: string) => {
        const currList: any[] = this.state.typeFilters;
        if (currList.some(value => value === buttonName)) {
            return 'primary';
        }
        return 'outline-primary';
    }

    public allButtonTypeColor = () => {
        if (this.state.typeFilters.length > 0) {
            return 'outline-primary';
        }
        return 'primary';
    }

    public handleFilterBoxClick = (filterName: string) => (event: any) => {
        const filterIndex = this.state.typeFilters.findIndex((value: any) => value === filterName);
        let listFilters: any[] = this.state.typeFilters;
        if (filterName === 'all') {
            listFilters = [];
        } else if (filterIndex < 0) {
            listFilters.push(filterName);
        } else {
            listFilters.splice(filterIndex, 1);
        }
        if (listFilters.length === 3) {
            listFilters = [];
        }
        this.setState({typeFilters: listFilters});
    }


    public render() {
        const selectedWell = this.WellsStore.copyWell;
        if(selectedWell) {
            return (
            <div>
                <div style={{marginBottom: '1rem'}}>
                    <Button color="primary" onClick={this.clearWell}>Clear Selected Well</Button>
                </div>
                <h4>
                    {selectedWell.wellName} | {' '}
                    {this.getOperatorName(selectedWell)} | {' '}
                    {this.getContractorName(selectedWell) + ' '  + selectedWell.rigNumber}
                </h4>
            </div>
            );
        }
        return <div>
        <div style={{marginBottom: '1rem'}}>
            <Button type='button' color={this.allButtonTypeColor()} onClick={this.handleFilterBoxClick('all')}>All</Button>
                {' '}
            <ButtonGroup>
                <Button type='button' color={this.buttonColor('Active')} onClick={this.handleFilterBoxClick('Active')}>Active</Button>
                <Button type='button' color={this.buttonColor('Finishing')} onClick={this.handleFilterBoxClick('Finishing')}>Finishing</Button>
                <Button type='button' color={this.buttonColor('Closed')} onClick={this.handleFilterBoxClick('Closed')}>Closed</Button>
            </ButtonGroup>
        </div>
        <DataTable
            list={this.formatWellTable()}
            onSelect={this.selectWell}
        />
        </div>;
    }
}

export default CopyWellSelectTable;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/CopyWellSelectTable/CopyWellSelectTable.tsx